import { computed } from 'vue';
import { LoadingStatuses } from '@/models/loading.interface';
import customBudgetPresenter from '@/presenters/custom-budget-presenter';
import store from '@/store';

export default class CustomBudgetBreakdownCode {

	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusCustomProducts();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public budgetCustom = computed((): string => {
		return `${customBudgetPresenter.budgetCustomFormatted.value} ${this.currency.value}`;
	});

	public budgetUsed = computed((): string => {
		const budget = customBudgetPresenter.budgetUsedFormatted.value;
		const budgetValueAsString = this.isBudgetUsedNegative.value ? `+ ${budget}` : `- ${budget.toString()}`;
		return `${budgetValueAsString} ${this.currency.value}`;
	});

	public budgetLeft = computed((): string => {
		const budget = customBudgetPresenter.budgetLeftFormatted.value;
		const budgetValueAsString = this.isBudgetLeftNegative.value ? `- ${budget}` : budget.toString();
		return `${budgetValueAsString} ${this.currency.value}`;
	});

	public wereCustomProductsModified = computed((): boolean => {
		const ids = store.getters.idsOfModifiedCustomProducts();
		return ids.length > 0;
	});

	private isBudgetLeftNegative = computed((): boolean => {
		return customBudgetPresenter.isBudgetLeftNegative.value;
	});

	private isBudgetUsedNegative = computed((): boolean => {
		return customBudgetPresenter.isBudgetUsedNegative.value;
	});

	private currency = computed((): string => {
		const storedValue = store.getters.currency();
		return storedValue ? storedValue : '';
	});
}
